import { router } from '@inertiajs/vue3';

/**
 * Resolve the current shop id used to build `shop/{shop_id}` Time Clock routes.
 *
 * The Time Clock control renders in the global top bar, so it can be mounted and
 * interacted with in contexts where the Inertia `master_config` prop is not yet
 * (or no longer) present — which makes Ziggy throw "'shop_id' parameter is
 * required". Fall back to the `/shop/{shop_id}` URL prefix and finally the legacy
 * `localStorage` shop id the rest of the app relies on, so a `shop_id` is always
 * available.
 *
 * @returns {number|string|null}
 */
export function resolveShopId() {
  const fromProps = router.page?.props?.master_config?.shop_id;
  if (fromProps) {
    return fromProps;
  }

  if (typeof window !== 'undefined') {
    const fromUrl = window.location.pathname.match(/\/shop\/(\d+)(?:\/|$)/);
    if (fromUrl) {
      return fromUrl[1];
    }

    const fromStorage = window.localStorage?.getItem('shop_id');
    if (fromStorage && fromStorage !== 'null' && fromStorage !== 'undefined') {
      return fromStorage;
    }
  }

  return null;
}
